// extracted by mini-css-extract-plugin
export default {"animateUpDown":"desktopMenu-module__animateUpDown--z42yr","up-down":"desktopMenu-module__up-down--wsKPS","upDown":"desktopMenu-module__up-down--wsKPS"};